/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * GeoStrat API
 * Geopolitical strategy game simulation API - manage nations, diplomacy, trade, and military operations
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiError,
  PatchedUserClassRequest,
  UserClass,
  UserClassSummaryStats
} from '../models';

import { customInstance } from '.././custom-instance';
import type { ErrorType } from '.././custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * ViewSet for managing UserClass profiles.
 *
 * Note: Despite the name 'UserViewSet', this actually manages UserClass objects,
 * which represent a user's profile within a specific class/account context.
 *
 * Supports:
 * - Retrieving user profiles (GET)
 * - Updating profile information and pictures (PATCH)
 * - Summary statistics endpoint
 *
 * Special behavior:
 * - When pk=0, returns the currently selected user class from session
 * - Filters results to current account and class (or admins)
 * - Optimized with select_related and prefetch_related for performance
 */
export const usersList = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClass[]>(
      {url: `/all/users/`, method: 'GET', signal
    },
      options);
    }




export const getUsersListQueryKey = () => {
    return [
    `/all/users/`
    ] as const;
    }


export const getUsersListQueryOptions = <TData = Awaited<ReturnType<typeof usersList>>, TError = ErrorType<ApiError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersList>>> = ({ signal }) => usersList(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersListQueryResult = NonNullable<Awaited<ReturnType<typeof usersList>>>
export type UsersListQueryError = ErrorType<ApiError>


export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = ErrorType<ApiError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersList>>,
          TError,
          Awaited<ReturnType<typeof usersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersList>>,
          TError,
          Awaited<ReturnType<typeof usersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersList<TData = Awaited<ReturnType<typeof usersList>>, TError = ErrorType<ApiError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * ViewSet for managing UserClass profiles.
 *
 * Note: Despite the name 'UserViewSet', this actually manages UserClass objects,
 * which represent a user's profile within a specific class/account context.
 *
 * Supports:
 * - Retrieving user profiles (GET)
 * - Updating profile information and pictures (PATCH)
 * - Summary statistics endpoint
 *
 * Special behavior:
 * - When pk=0, returns the currently selected user class from session
 * - Filters results to current account and class (or admins)
 * - Optimized with select_related and prefetch_related for performance
 */
export const usersRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClass>(
      {url: `/all/users/${id}/`, method: 'GET', signal
    },
      options);
    }




export const getUsersRetrieveQueryKey = (id: number,) => {
    return [
    `/all/users/${id}/`
    ] as const;
    }


export const getUsersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRetrieve>>> = ({ signal }) => usersRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersRetrieve>>>
export type UsersRetrieveQueryError = ErrorType<ApiError>


export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * ViewSet for managing UserClass profiles.
 *
 * Note: Despite the name 'UserViewSet', this actually manages UserClass objects,
 * which represent a user's profile within a specific class/account context.
 *
 * Supports:
 * - Retrieving user profiles (GET)
 * - Updating profile information and pictures (PATCH)
 * - Summary statistics endpoint
 *
 * Special behavior:
 * - When pk=0, returns the currently selected user class from session
 * - Filters results to current account and class (or admins)
 * - Optimized with select_related and prefetch_related for performance
 */
export const usersPartialUpdate = (
    id: number,
    patchedUserClassRequest?: PatchedUserClassRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(patchedUserClassRequest?.fullName !== undefined) {
 formData.append(`fullName`, patchedUserClassRequest.fullName);
 }

      return customInstance<UserClass>(
      {url: `/all/users/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getUsersPartialUpdateMutationOptions = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersPartialUpdate>>, TError,{id: number;data?: PatchedUserClassRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof usersPartialUpdate>>, TError,{id: number;data?: PatchedUserClassRequest}, TContext> => {

const mutationKey = ['usersPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersPartialUpdate>>, {id: number;data?: PatchedUserClassRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  usersPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersPartialUpdate>>>
    export type UsersPartialUpdateMutationBody = PatchedUserClassRequest | undefined
    export type UsersPartialUpdateMutationError = ErrorType<ApiError>

    export const useUsersPartialUpdate = <TError = ErrorType<ApiError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersPartialUpdate>>, TError,{id: number;data?: PatchedUserClassRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersPartialUpdate>>,
        TError,
        {id: number;data?: PatchedUserClassRequest},
        TContext
      > => {
      return useMutation(getUsersPartialUpdateMutationOptions(options), queryClient);
    }
    /**
 * Get summary statistics for a specific UserClass
 */
export const usersSummaryStatsRetrieve = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<UserClassSummaryStats>(
      {url: `/all/users/${id}/summary-stats/`, method: 'GET', signal
    },
      options);
    }




export const getUsersSummaryStatsRetrieveQueryKey = (id: number,) => {
    return [
    `/all/users/${id}/summary-stats/`
    ] as const;
    }


export const getUsersSummaryStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError = ErrorType<ApiError>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersSummaryStatsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>> = ({ signal }) => usersSummaryStatsRetrieve(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersSummaryStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>>
export type UsersSummaryStatsRetrieveQueryError = ErrorType<ApiError>


export function useUsersSummaryStatsRetrieve<TData = Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSummaryStatsRetrieve<TData = Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersSummaryStatsRetrieve<TData = Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersSummaryStatsRetrieve<TData = Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError = ErrorType<ApiError>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersSummaryStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersSummaryStatsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






